import React, { useState } from 'react';
import '../style/About.scss';
// component
import Header from '../components/public/Header';
// React Bootstrap
import { Container, Row, Col, Tab, Nav } from 'react-bootstrap';
// react redux
import { connect } from 'react-redux';
// react-router-dom
import { Link } from 'react-router-dom';
// import Gallery from 'react-photo-gallery';
import PhotoGallery from '../components/thirdParty/PhotoGallery';

function About({ lang }) {
  const [tsangsar, setTsangsar] = useState(true);
  const [tsangsarPongue, setTsangsrPongue] = useState(false);
  const topPhotos = [
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fabout1.jpg?alt=media&token=03998d92-ea24-44af-8626-c5f2309daa44',
      width: 3,
      height: 4,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fabout0.jpg?alt=media&token=32ce6a5d-a453-44ab-b424-e3f91fe213f7',
      width: 3,
      height: 4,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fabout1.1.jpg?alt=media&token=2c30c41b-ab90-484b-9cce-5104f1e2a65b',
      width: 3,
      height: 4,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fabout1.2.jpg?alt=media&token=af3b1df6-4a18-48ef-8801-bd21108d7d10',
      width: 4,
      height: 3,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fabout2.jpg?alt=media&token=f1a381bf-c636-49a0-818c-c445764e02f7',
      width: 2,
      height: 3,
    },
  ];

  const tabList1 = [
    {
      id: 1,
      to: null,
      title: 'ཚང་གསར།'
    },
    {
      id: 2,
      to: null,
      title: 'སྐུ་འབུམ་གྱི་སྐབས།'
    },
    {
      id: 3,
      to: null,
      title: 'སྙིང་ཐང་གི་སྐབས།'
    },
    {
      id: 4,
      to: null,
      title: 'གྲྭ་ནང་གི་སྐབས།'
    },
    {
      id: 5,
      to: null,
      title: 'ཚང་གསར་གདུང་བརྒྱུད།'
    },
  ]


  const tabList2 = [
    {
      id: 1,
      to: '/about',
      title: 'ཚང་གསར་དཔོན་བརྒྱུད།'
    },
    {
      id: 2,
      to: null,
      title: 'ལྕི་ཉིན་དཔོན་ཚང་།'
    },
    {
      id: 2,
      to: null,
      title: 'འགྲམ་དཔོན་ཚང་།'
    },
    {
      id: 2,
      to: null,
      title: 'རྫ་ལྷུག་དཔོན་ཚང་།'
    },
    {
      id: 2,
      to: null,
      title: 'མདོ་ཐང་དཔོན་ཚང་།'
    },
  ]
  return (
    <>
      <Header />
      <Container className='about'>
        {
          lang === 'CH' ? (
            // chinese Section
            <div className='aboutBody p-5'>
              <Row className='aboutContent d-flex align-items-center justify-content-center'>
                <Col className='align-items-center  justify-content-center'>
                  {/* <Image src={kunga} fluid rounded className='aboutImage' /> */}
                  <PhotoGallery images={topPhotos} />
                </Col>
              </Row>
              <Row>
                <Col>
                  <h3 className='text-left text-secondary chinese mt-sm-4 mt-lg-3'>
                    仁波切簡介
                  </h3>
                  <p className='chineseParagraph'>
                    <br />
                  倉薩貢噶仁波切，於西元1979年出生於東藏地區，仁波切自幼就信仰三寶，先後被巴融噶舉法王蔣央洛竹仁欽與昂稱祖古認證為丹增多傑的第五位轉世，仁波切是藏傳佛教噶舉派中四大派之巴融噶舉教派的法脈傳承者，八歲起仁波切師從多位尊貴的上師如
                  第四世的蔣央洛竹仁欽尊者為巴融噶舉的法王與傳承珍寶並身兼四派之傳承。倉薩貢噶仁波切在佛學院期間,進行了為期九年的佛學聞思修,並於二十三歲時圓滿完成了三年三個月的閉關。完滿出關後接著擔任閉關中心指導上師。仁波切為了饒益更多有情眾生，於西元2002年起開始在世界各地弘法，仁波切在新加坡和台灣分別成立八融噶舉律美多傑佛法中心和八融噶舉菩提佛學會，八融般若文化教育協會。2013年仁波切於青海曩謙縣創辦孤貧職業學校；又於2018年創立民辦幼兒園，致力於偏鄉兒童的啟蒙教育。
                </p>
                </Col>
              </Row>
            </div>
          ) : (
              // Tibetan Section
              <div className='kyaguBody pt-4 pr-5 pl-5'>
                {
                  tsangsar ? (
                    <>
                      <Row className='kyaguContent d-flex align-items-center justify-content-center'>
                        <Col className='align-items-center'>
                          {/* Header Image */}
                          <PhotoGallery images={topPhotos} />
                          {/* Title */}
                          <h3 className='text-left text-secondary tibetan_Dutsa mb-3'>
                            <br />
                          </h3>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <Tab.Container id='left-tabs' defaultActiveKey='0'>
                            <Row>
                              <Col sm={5} md={3}>
                                <Nav variant='pills' className='flex-column '>
                                  {/* Tabs */}
                                  {
                                    tabList1.map((tabItem, index) => {
                                      return (
                                        <Nav.Item className='navItem' key='index'>
                                          <Nav.Link eventKey={index}>
                                            <h4>{tabItem.title}</h4>
                                          </Nav.Link>
                                        </Nav.Item>)
                                    })
                                  }
                                  <Nav.Item className='navItem' onClick={() => {
                                    setTsangsar(false);
                                    setTsangsrPongue(true);
                                  }} >
                                    <Nav.Link>
                                      <h4> ཚང་གསར་དཔོན་བརྒྱུད། ▶️️</h4>
                                    </Nav.Link>
                                  </Nav.Item>


                                  <Nav.Item className='navItem'>
                                    <Nav.Link eventKey='6'>
                                      <h4>ཚང་གསར་བླ་བརྒྱུད།</h4>
                                    </Nav.Link>
                                  </Nav.Item>

                                  <Nav.Item className='navItem'>
                                    <Nav.Link eventKey='7'>
                                      <h4>ཚང་གསར་དགོན་སྡེ།</h4>
                                    </Nav.Link>
                                  </Nav.Item>
                                  <Nav.Item className='navItem'>
                                    <Nav.Link eventKey='8'>
                                      <h4>ས་མི་ཆུད་མཚམས།</h4>
                                    </Nav.Link>
                                  </Nav.Item>
                                </Nav>
                              </Col>

                              {/* Content */}
                              <Col sm={7} md={9}>
                                <Tab.Content className='tabContent'>
                                  <Tab.Pane eventKey='0' className='tabPane'>
                                    <h1>ཚང་སར་ཀུན་དགའ།</h1>
                                    <p className='tibetan_OuChan1 p-2 text-left'>
                                      ང་རང་སྐྱེས་ཡུལ་ནི་ཁམས་ནང་ཆེན་རེ་བླ་དོམ་ཐང་ཞེས་པའི་གྲོང་གསེབ་ཆུང་ཆུང་ཞིག་ཏུ་ཡིན། དེ་ཡང་ཕ་ཚང་སར་བྱམས་པ་འཆི་མེད་དང་མ་འཇའ་བཟའ་ནམ་ཆོས་གཉིས་ཀྱི་བུར་༡༩༧༩ ལོར་སྐྱེས། ཆུང་དུས་ཨ་མར་ཐབ་གཡོག་དང་ནང་ལས་ཙག་ཙིག་གི་ཕྱག་གཡོག་དང་ཕྱུག་འཚོ་སྐྱོང་བྱེད་རོགས་བྱེད་ཞོར་ཕ་རྒན་བཀའ་དྲིན་ཅན་གྱི་མདུན་ནས་ཡི་གེ་འབྲི་ཀློག་དང་ཡིག་གཟུགས་སྒྱུ་རྩལ། དཀྱིལ་འཁོར་གྱི་ཐིག་རྡུལ་ཚོན། བོད་ཀྱི་རྡོ་བརྐོས་རི་མོ་དང་ནག་རྩིས། གསོ་བ་རིག་པ་སོགས་ལ་སློབ་སྦྱོང་བྱས། དེ་ནས་འབའ་རོམ་བཀའ་བརྒྱུད་པའི་བརྒྱུད་འཛིན་གྱི་གདན་ས་གནམ་གྱི་ཚང་སར་དགོན་པའི་ཆོས་གྲྭར་ཞུགས་ཏེ་རང་ལུགས་ཀྱི་འདོན་རྟ་དབྱངས་རོལ། ཆོ་ག་ཆོས་སྤྱོད་གར་འཆམ་སོགས་ལ་སྦྱང་བརྩོན་བྱས། རང་དགོན་གཙང་རྔ་ཁར་བཤད་གྲྭ་གསར་འཛུགས་སྐབས་མཁན་པོ་ལོ་ཡག་སོགས་གདན་དྲང་སྐབས་སུ། སྤྱོད་འཇུག་དང་མངོན་པ་མཛོད་སོགས་ནང་དོན་རིག་པའི་གཞུང་ཆེན་ཁག་ལ་སློབ་སྦྱོང་བྱས། དེ་ནས་སྒྲུབ་སྡེ་བཀྲ་ཤིས་ལྷ་བརྩེ་རུ་ལོ་གསུམ་ཟླ་གསུམ་རིང་སྤྱིར་སྔགས་བླ་མེད་ཀྱི་གསང་བའི་ཟབ་ཆོས་སྐོར་གྲངས་མང་ཞིག་དང་། ཡང་སྒོས་གདམས་ངག་གི་བརྒྱུད་པའི་བྱིན་རླབས་མྱུར་བའི་དཔལ་ལྡན་འབའ་རོམ་བཀའ་བརྒྱུད་ཀྱི་སྔོན་འགྲོ་ནས་བཟུང་ཐབས་གྲོལ་གྱི་ཆོས་སྐོར་ཡོང་རྫོགས་ཀྱི་དབང་ལུང་དང་། མན་ངག་གི་ཉིང་ཁུ་རྣམས་ཞུས་ཏེ་ལོ་གསུམ་ཟླ་གསུམ་རིང་སྒྲུབ་པའི་ཉམས་ལེན་རྩེ་གཅིག་ཏུ་བྱེད་ཁུར་བྱས། ༢༠༠༢ ལོར་བལ་ཡུལ་ཏུ་ཕྱིན་ནས་ལོ་གཅིག་ལྷག་གནས་དེར་དབྱིན་སྐད་སྦྱང་ཁུལ་བྱས།
                                      སྤྱི་ལོ།༢༠༠༤ལོར་ཐའེ་ཝན་དུ་འབྱོར་༢༠༠༨ལོར་རྒྱ་རིགས་ནང་ཆོས་ལ་ཐུག་སྣང་ཡོད་མཁན་དག་ལ་དམིགས་ནས་འབའ་རོམ་བཀའ་བརྒྱུད་བྱང་ཆུབ་ཆོས་ཚོགས་ཐོག་མར་བཙུགས། དཔེ་ཁྲིད་དང་སྒོམ་ཁྲིད་སྤྱི་ཚོགས་ཞབས་ཞུ་མི་ཉུང་བ་ཞིག་གཉེར།
                                      སྤྱི་ལོ།༢༠༡༢ལོར་ཆོས་རྗེ་དཔལ་ལྡན་འབའ་རོམ་པའི་ཕྱག་ཆེན་ཆོས་དྲུག་གི་སྔོན་འགྲོའི་ཁྲིད་རིམ་དབྱིན་སྐད་རྒྱ་སྐད་སོག་སྐད་ལ་བསྒྱུར་བའི་མཐུན་སྦྱོར་གནང་ཏེ་དཔར་སྐྲུན་འགྲེམ་སྤེལ་ཞུས།
                                      སྤྱི་ལོ།༢༠༡༠ཚང་སར་ལྷ་རྒན་གྱིས་རྩོམ་བསྒྲིགས་གནང་བའི་སྐར་མཛོད་རྩིས་མགོ་ལྔ་བཅུ་པ་ཕྱག་བྲིས་བྱིན་ལྡན་དཔེ་རྒྱུན་ཆད་ལ་ཉེ་བ་དེ་ཉིད་ཉམས་མེད་བསྐལ་པའི་བར་དུ་གནས་ཕྱིར་ཕྱག་བྲིས་དངོས་མ་དེ་ཉིད་མ་སྨད་དག་གཙང་གིས་དཔར་འགྲེམ་ཞུས།
                                      སྤྱི་ལོ།༢༠༡༥-༢༠༡༨བར་ལོ་གསུང་རིང་ཐའེ་ཝན་ཐའེ་པེ་རུ་རྒྱལ་ཁབ་རིམ་པའི་བཙོན་ཁང་ནང་གི་བཙོན་པ་རྣམས་ལ་ལུས་སྦྱོང་དང་སེམས་སྦྱོང་། ད་དུང་ནང་ཆོས་དང་མི་ཚེ་བར་འབྲེལ་བའི་སྐོར་ནས་དམ་པའི་ཆོས་ཀྱི་གཏམ་གླེང་མི་ཉུང་བར་བརྩོན་པ་ཆེར་བསྐྱེད་བྱས་པར་བརྟེན། ཁོ་ཚོར་དངོས་ཡོད་ཀྱི་ཕན་པ་ཡག་པོ་བྱུང་། སྤྱི་ལོ།༢༠༡༧ལོར་འབའ་རོམ་ཤེས་རབ་རིག་གཞུང་ལྷན་ཚོགས་བཙུགས་ཏེ་བོད་ཀྱི་ཐང་ཀའི་རི་མོའི་སྒྱུ་རྩལ་དང་ཡིག་གཟུགས་སྒྱུ་རྩལ་དཀྱིལ་འཁོར་གྱི་ཐིག་རྡུལ་ཚོན་སོགས་སློབ་ཁྲིད་བྱས། གཞན་ཡང་ཐའི་ཝན་གྱི་སློབ་གྲྭ་ཆེ་མོ་ཁག་དང་སྤྱི་སྒེར་གྱི་ཚོགས་སྡེ་ཁག་ལ་སྒོམ་དང་འཕྲུལ་འཁོར། དྲན་པ་ཉེར་བཞག་སོགས་ཀྱི་སྒོམ་ཁྲིད་གང་མང་བྱས།
                                      སྤྱི་ལོ།༢༠༠༩ནས་བཟུང་། ཕ་ཡུལ་དུ་སློབ་གྲྭ་གསར་འཛུགས་ཀྱི་ལས་ཀ་གཉེར། རང་ཉིད་བོད་པ་ཞིག་ཡིན་པའི་ངོས་ནས་བོད་ཀྱི་ཆོས་དང་རིག་གཞུང་སྐད་དང་ཡི་གེ་འདི་དག་མི་ཉམས་གོང་འཕེལ་དུ་གཏོང་བ་དང་། ཉམས་པ་སླར་གསོའི་འོས་འགན་ཞིག་ཕྲག་ཏུ་ཡོད་པ་ཤེས་ཀྱང་། མི་ཚེ་འདི་གཞན་ཡུལ་ལ་གོམས་ཆེ་བའི་དབང་གིས་སྐབས་དང་དུས་སུ་སེམས་ལ་ཡང་བསྔངས་སྐྲག་ཡོང་གིན་ཡོད་ཅིང་། དེས་ཕྱིར་གཞན་དག་བྱ་ཐབས་བྲལ་ཡང་ཕ་ཡུལ་དུ་རང་རིགས་ཀྱི་སློབ་གསོའི་ལས་ཀ་ཞིག་འགྲུབ་ན་བསམ་པའི་སེམས་ཁུལ་ཞིག་ངང་ནས་སྐྱེས་པ་ལྟར། བོད་ཡུལ་གྱི་ས་ཆ་གང་ས་གང་དུ་གང་ས་ཅི་ཐད་ནས་དཀའ་ངལ་ཡོད་པའི་བྱིས་པ་རྣམས་ལ་སློབ་སྦྱོང་གི་ཉེར་མཁོ་དང་། འཚོ་བའི་ཁ་གསབ་ཟས་གོས་གང་ཐད་ལྷག་བསམ་གཙང་མའི་དངོས་ཤུགས་རྒྱུད་གསུམ་ནས་རོགས་རམ་ཅི་ནུས་སུ་འབད་པ་ཡིན། དམིགས་བསལ་དུ་སློབ་གྲྭ་མེད་པའི་ས་ཆ་རུ་སྒེར་གཉེར་སློབ་གྲྭ་༼ བཀྲ་ཤིས་དགེ་མཚན་དམངས་གཉེར་བྱིས་སྐྱོང་ཁང་དང་། ནང་ཆེན་བཀྲ་ཤིས་དགེ་མཚན་དྭ་དབུལ་ལག་རྩལ་སློབ་གྲྭ་༽ གཉིས་སློབ་གསོའི་སྡེ་ཁག་མི་འདྲ་བ་གཉིས་གསར་དུ་བཙུགས་ཡོད། ད་སྐབས་ཡང་རིམ་བཞིན་ཡར་རྒྱས་ཀྱི་གོམ་པ་སྤོ་བཞིན་པའི་སྒང་ཡིན་ནོ།  །
                              </p>
                                  </Tab.Pane>
                                </Tab.Content>
                              </Col>
                            </Row>
                          </Tab.Container>
                        </Col>
                      </Row>
                    </>
                  ) : tsangsarPongue ? (
                    <>
                      <Row className='kyaguContent d-flex align-items-center justify-content-center'>
                        <Col className='align-items-center'>
                          {/* Header Image */}
                          <PhotoGallery images={topPhotos} />
                          {/* Title */}
                          <h3 className='text-left text-secondary tibetan_Dutsa mb-3'>
                            <br />
                          </h3>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <Tab.Container id='left-tabs' defaultActiveKey='0'>
                            <Row>
                              <Col sm={5} md={3}>
                                <Nav variant='pills' className='flex-column '>
                                  {/* Tabs */}
                                  <Nav.Item className='navItem' onClick={() => {
                                    setTsangsar(true);
                                    setTsangsrPongue(false);
                                  }} >
                                    <Nav.Link>
                                      <h2> ཚང་གསར། ⬅️️️</h2>
                                    </Nav.Link>
                                  </Nav.Item>
                                  {
                                    tabList2.map((tabItem, index) => {
                                      return (
                                        <Nav.Item className='navItem' key='index'>
                                          <Nav.Link eventKey={index}>
                                            <h4>{tabItem.title}</h4>
                                          </Nav.Link>
                                        </Nav.Item>)
                                    })
                                  }
                                </Nav>
                              </Col>

                              {/* Content */}
                              <Col sm={7} md={9}>
                                <Tab.Content className='tabContent'>
                                  <Tab.Pane eventKey='0' className='tabPane'>
                                    <h1>ཚང་གསར་དཔོན་བརྒྱུད།</h1>
                                    <p className='tibetan_OuChan1 p-2 text-left'>
                                      ང་རང་སྐྱེས་ཡུལ་ནི་ཁམས་ནང་ཆེན་རེ་བླ་དོམ་ཐང་ཞེས་པའི་གྲོང་གསེབ་ཆུང་ཆུང་ཞིག་ཏུ་ཡིན། དེ་ཡང་ཕ་ཚང་སར་བྱམས་པ་འཆི་མེད་དང་མ་འཇའ་བཟའ་ནམ་ཆོས་གཉིས་ཀྱི་བུར་༡༩༧༩ ལོར་སྐྱེས། ཆུང་དུས་ཨ་མར་ཐབ་གཡོག་དང་ནང་ལས་ཙག་ཙིག་གི་ཕྱག་གཡོག་དང་ཕྱུག་འཚོ་སྐྱོང་བྱེད་རོགས་བྱེད་ཞོར་ཕ་རྒན་བཀའ་དྲིན་ཅན་གྱི་མདུན་ནས་ཡི་གེ་འབྲི་ཀློག་དང་ཡིག་གཟུགས་སྒྱུ་རྩལ། དཀྱིལ་འཁོར་གྱི་ཐིག་རྡུལ་ཚོན། བོད་ཀྱི་རྡོ་བརྐོས་རི་མོ་དང་ནག་རྩིས། གསོ་བ་རིག་པ་སོགས་ལ་སློབ་སྦྱོང་བྱས། དེ་ནས་འབའ་རོམ་བཀའ་བརྒྱུད་པའི་བརྒྱུད་འཛིན་གྱི་གདན་ས་གནམ་གྱི་ཚང་སར་དགོན་པའི་ཆོས་གྲྭར་ཞུགས་ཏེ་རང་ལུགས་ཀྱི་འདོན་རྟ་དབྱངས་རོལ། ཆོ་ག་ཆོས་སྤྱོད་གར་འཆམ་སོགས་ལ་སྦྱང་བརྩོན་བྱས། རང་དགོན་གཙང་རྔ་ཁར་བཤད་གྲྭ་གསར་འཛུགས་སྐབས་མཁན་པོ་ལོ་ཡག་སོགས་གདན་དྲང་སྐབས་སུ། སྤྱོད་འཇུག་དང་མངོན་པ་མཛོད་སོགས་ནང་དོན་རིག་པའི་གཞུང་ཆེན་ཁག་ལ་སློབ་སྦྱོང་བྱས། དེ་ནས་སྒྲུབ་སྡེ་བཀྲ་ཤིས་ལྷ་བརྩེ་རུ་ལོ་གསུམ་ཟླ་གསུམ་རིང་སྤྱིར་སྔགས་བླ་མེད་ཀྱི་གསང་བའི་ཟབ་ཆོས་སྐོར་གྲངས་མང་ཞིག་དང་། ཡང་སྒོས་གདམས་ངག་གི་བརྒྱུད་པའི་བྱིན་རླབས་མྱུར་བའི་དཔལ་ལྡན་འབའ་རོམ་བཀའ་བརྒྱུད་ཀྱི་སྔོན་འགྲོ་ནས་བཟུང་ཐབས་གྲོལ་གྱི་ཆོས་སྐོར་ཡོང་རྫོགས་ཀྱི་དབང་ལུང་དང་། མན་ངག་གི་ཉིང་ཁུ་རྣམས་ཞུས་ཏེ་ལོ་གསུམ་ཟླ་གསུམ་རིང་སྒྲུབ་པའི་ཉམས་ལེན་རྩེ་གཅིག་ཏུ་བྱེད་ཁུར་བྱས། ༢༠༠༢ ལོར་བལ་ཡུལ་ཏུ་ཕྱིན་ནས་ལོ་གཅིག་ལྷག་གནས་དེར་དབྱིན་སྐད་སྦྱང་ཁུལ་བྱས།
                                      སྤྱི་ལོ།༢༠༠༤ལོར་ཐའེ་ཝན་དུ་འབྱོར་༢༠༠༨ལོར་རྒྱ་རིགས་ནང་ཆོས་ལ་ཐུག་སྣང་ཡོད་མཁན་དག་ལ་དམིགས་ནས་འབའ་རོམ་བཀའ་བརྒྱུད་བྱང་ཆུབ་ཆོས་ཚོགས་ཐོག་མར་བཙུགས། དཔེ་ཁྲིད་དང་སྒོམ་ཁྲིད་སྤྱི་ཚོགས་ཞབས་ཞུ་མི་ཉུང་བ་ཞིག་གཉེར།
                                      སྤྱི་ལོ།༢༠༡༢ལོར་ཆོས་རྗེ་དཔལ་ལྡན་འབའ་རོམ་པའི་ཕྱག་ཆེན་ཆོས་དྲུག་གི་སྔོན་འགྲོའི་ཁྲིད་རིམ་དབྱིན་སྐད་རྒྱ་སྐད་སོག་སྐད་ལ་བསྒྱུར་བའི་མཐུན་སྦྱོར་གནང་ཏེ་དཔར་སྐྲུན་འགྲེམ་སྤེལ་ཞུས།
                                      སྤྱི་ལོ།༢༠༡༠ཚང་སར་ལྷ་རྒན་གྱིས་རྩོམ་བསྒྲིགས་གནང་བའི་སྐར་མཛོད་རྩིས་མགོ་ལྔ་བཅུ་པ་ཕྱག་བྲིས་བྱིན་ལྡན་དཔེ་རྒྱུན་ཆད་ལ་ཉེ་བ་དེ་ཉིད་ཉམས་མེད་བསྐལ་པའི་བར་དུ་གནས་ཕྱིར་ཕྱག་བྲིས་དངོས་མ་དེ་ཉིད་མ་སྨད་དག་གཙང་གིས་དཔར་འགྲེམ་ཞུས།
                                      སྤྱི་ལོ།༢༠༡༥-༢༠༡༨བར་ལོ་གསུང་རིང་ཐའེ་ཝན་ཐའེ་པེ་རུ་རྒྱལ་ཁབ་རིམ་པའི་བཙོན་ཁང་ནང་གི་བཙོན་པ་རྣམས་ལ་ལུས་སྦྱོང་དང་སེམས་སྦྱོང་། ད་དུང་ནང་ཆོས་དང་མི་ཚེ་བར་འབྲེལ་བའི་སྐོར་ནས་དམ་པའི་ཆོས་ཀྱི་གཏམ་གླེང་མི་ཉུང་བར་བརྩོན་པ་ཆེར་བསྐྱེད་བྱས་པར་བརྟེན། ཁོ་ཚོར་དངོས་ཡོད་ཀྱི་ཕན་པ་ཡག་པོ་བྱུང་། སྤྱི་ལོ།༢༠༡༧ལོར་འབའ་རོམ་ཤེས་རབ་རིག་གཞུང་ལྷན་ཚོགས་བཙུགས་ཏེ་བོད་ཀྱི་ཐང་ཀའི་རི་མོའི་སྒྱུ་རྩལ་དང་ཡིག་གཟུགས་སྒྱུ་རྩལ་དཀྱིལ་འཁོར་གྱི་ཐིག་རྡུལ་ཚོན་སོགས་སློབ་ཁྲིད་བྱས། གཞན་ཡང་ཐའི་ཝན་གྱི་སློབ་གྲྭ་ཆེ་མོ་ཁག་དང་སྤྱི་སྒེར་གྱི་ཚོགས་སྡེ་ཁག་ལ་སྒོམ་དང་འཕྲུལ་འཁོར། དྲན་པ་ཉེར་བཞག་སོགས་ཀྱི་སྒོམ་ཁྲིད་གང་མང་བྱས།
                                      སྤྱི་ལོ།༢༠༠༩ནས་བཟུང་། ཕ་ཡུལ་དུ་སློབ་གྲྭ་གསར་འཛུགས་ཀྱི་ལས་ཀ་གཉེར། རང་ཉིད་བོད་པ་ཞིག་ཡིན་པའི་ངོས་ནས་བོད་ཀྱི་ཆོས་དང་རིག་གཞུང་སྐད་དང་ཡི་གེ་འདི་དག་མི་ཉམས་གོང་འཕེལ་དུ་གཏོང་བ་དང་། ཉམས་པ་སླར་གསོའི་འོས་འགན་ཞིག་ཕྲག་ཏུ་ཡོད་པ་ཤེས་ཀྱང་། མི་ཚེ་འདི་གཞན་ཡུལ་ལ་གོམས་ཆེ་བའི་དབང་གིས་སྐབས་དང་དུས་སུ་སེམས་ལ་ཡང་བསྔངས་སྐྲག་ཡོང་གིན་ཡོད་ཅིང་། དེས་ཕྱིར་གཞན་དག་བྱ་ཐབས་བྲལ་ཡང་ཕ་ཡུལ་དུ་རང་རིགས་ཀྱི་སློབ་གསོའི་ལས་ཀ་ཞིག་འགྲུབ་ན་བསམ་པའི་སེམས་ཁུལ་ཞིག་ངང་ནས་སྐྱེས་པ་ལྟར། བོད་ཡུལ་གྱི་ས་ཆ་གང་ས་གང་དུ་གང་ས་ཅི་ཐད་ནས་དཀའ་ངལ་ཡོད་པའི་བྱིས་པ་རྣམས་ལ་སློབ་སྦྱོང་གི་ཉེར་མཁོ་དང་། འཚོ་བའི་ཁ་གསབ་ཟས་གོས་གང་ཐད་ལྷག་བསམ་གཙང་མའི་དངོས་ཤུགས་རྒྱུད་གསུམ་ནས་རོགས་རམ་ཅི་ནུས་སུ་འབད་པ་ཡིན། དམིགས་བསལ་དུ་སློབ་གྲྭ་མེད་པའི་ས་ཆ་རུ་སྒེར་གཉེར་སློབ་གྲྭ་༼ བཀྲ་ཤིས་དགེ་མཚན་དམངས་གཉེར་བྱིས་སྐྱོང་ཁང་དང་། ནང་ཆེན་བཀྲ་ཤིས་དགེ་མཚན་དྭ་དབུལ་ལག་རྩལ་སློབ་གྲྭ་༽ གཉིས་སློབ་གསོའི་སྡེ་ཁག་མི་འདྲ་བ་གཉིས་གསར་དུ་བཙུགས་ཡོད། ད་སྐབས་ཡང་རིམ་བཞིན་ཡར་རྒྱས་ཀྱི་གོམ་པ་སྤོ་བཞིན་པའི་སྒང་ཡིན་ནོ།  །
                              </p>
                                  </Tab.Pane>
                                  <Tab.Pane eventKey='1' className='tabPane'>
                                    <h1>ཚང་གསར་དཔོན་བརྒྱུད།</h1>
                                    <p className='tibetan_OuChan1 p-2 text-left'>
                                      test1
                                    </p>
                                  </Tab.Pane>
                                  <Tab.Pane eventKey='2' className='tabPane'>
                                    <h1>ཚང་གསར་དཔོན་བརྒྱུད།</h1>
                                    <p className='tibetan_OuChan1 p-2 text-left'>
                                      test 2
                              </p>
                                  </Tab.Pane>
                                  <Tab.Pane eventKey='3' className='tabPane'>
                                    <h1>ཚང་གསར་དཔོན་བརྒྱུད།</h1>
                                    <p className='tibetan_OuChan1 p-2 text-left'>
                                      test 3
                              </p>
                                  </Tab.Pane>
                                  <Tab.Pane eventKey='4' className='tabPane'>
                                    <h1>ཚང་གསར་དཔོན་བརྒྱུད།</h1>
                                    <p className='tibetan_OuChan1 p-2 text-left'>
                                      test 4
                              </p>
                                  </Tab.Pane>
                                </Tab.Content>
                              </Col>
                            </Row>
                          </Tab.Container>
                        </Col>
                      </Row>
                    </>
                  ) : (
                        null
                      )
                }

              </div>

            )
        }

      </Container>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    lang: state.lang.lang,
  };
};

export default connect(mapStateToProps)(About);
